import CircularProgress from "@mui/material/CircularProgress";
import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { FlexColumn, FlexColumnDiv } from "./common.styles";
import { HXCircularMobileLogos } from "./HXMobileLogos";
import { Text } from "./HXMobilePage.styles";
import { Title } from "./PatientConsentManagerShared.styles";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
export const ContentContainer = styled(FlexColumnDiv) `
    padding: 10px 0px;
    gap: 10px;
    width: 100%;
    display: flex;
    align-items: center;
`;
export const LoadingPlaceholderParent = styled.div `
    width: 104px;
    height: 104px;
    align-self: center;
    padding-top: 8px;
    padding-bottom: 24px;
`;
export const LoadingTitle = styled(Title) `
    padding: 0px 24px;
    align-self: center;
    font-size: ${fontSizes.MOBILE_TITLE};
    font-weight: ${fontWeights.NORMAL};
`;
export const LoadingText = styled(Text) `
    padding: 0px 24px;
    align-self: center;
    animation: fadeIn 0.5s ease-in-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;
export const LoadingProgressBox = styled.div `
    width: 104px;
    height: 104px;
    z-index: 1;
`;
export const LoadingInnerProgressBox = styled.div `
    margin-left: 8px;
    margin-top: -92px;
    width: 88px;
    height: 88px;
    z-index: 2;
`;
export const LoadingProgress = styled(CircularProgress) `
    width: 100%;
    height: 100%;
    color: ${colors.sunset_main};
`;
export const LoadingLogo = styled(HXCircularMobileLogos) `
    width: 100%;
    height: 100%;
`;
export const LoadingProgressDescription = styled(FlexColumn) `
    justify-content: center;
    gap: 16px;
    text-align: center;
`;
